/**
 * Created by mykurisu on 2017/8/22.
 */
const defaults = {
    selectType: 'wallet_list',
    walletDetailInit: false,
    walletDetail: null,
    walletDetailList: null,
};

export default (state = defaults, action) => {
    switch (action.type) {
        case 'SET_WALLET_DETAIL_TYPE':
            return {...state, selectType: action.payload};
        case 'WALLET_DETAIL_INIT':
            return {...state, walletDetailInit: true, walletDetail: action.payload};
        case 'WALLET_DETAIL_APPEND':
            return {...state, walletDetailList: action.payload};
        case 'WALLET_DETAIL_CLEAR':
            return defaults;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/walletDetail.js